<template>
  
	<div class="layerParam">
		<label>
			<div class="layerParam_title">{{title}}</div>


			<div class="layerParam_nograph" v-if="param().expression == undefined">

				<input v-if="type == 'float'" type="number" step="0.1" class="layerParam_nograph_float"
				v-model="value" v-on:change="onChangeVal" />

				<div v-if="type == 'color'" class="layerParam_nograph_color" v-on:click="editColor">
					<button 
					v-bind:style="{ backgroundColor: 'rgb('+param().r+', '+param().g+', '+param().b+')' }"
					>
					</button>
					<input type="text" readonly v-bind:value="param().r+', '+param().g+', '+param().b">
				</div>

				<label  v-if="type == 'mapalign'" class="switch switchboolparam">
					<input type="checkbox" v-on:change="mapAlignChange" v-bind:checked="param()" />
					<span class="slider round"></span>
				</label>

				<label  v-if="type == 'clusterbool'" class="switch switchboolparam">
					<input type="checkbox" v-on:change="clusterChange" v-bind:checked="param()" />
					<span class="slider round"></span>
				</label>
				

				<button class="layerParam_editgraph" v-if="['color', 'float'].includes(type)"
				v-on:click="openGraph">
					Switch to behaviour blueprint
				</button>

			</div>

			<div class="layerParam_nograph" v-if="param().expression != undefined">

				<button class="layerParam_openGraph"
				v-on:click="openGraph">
					Open behaviour blueprint
				</button>
				

				<button class="layerParam_removegraph"
				v-on:click="setConstant">
					Switch to constant value
				</button>

			</div>
			


		</label>
	</div>

</template>

<script>


export default {
	name: 'layerParam',
	props: {
		okanMap : Object,
		layer:	Object,
		params: Array,
		title: String,
		type: String
	},
	data: function() {
		return {

			value : this.param().expression != undefined ? this.param().expression : this.param(),
			graph : this.param().graph != undefined && this.param().graph != null ? this.param().graph : null

		}
	},
	mounted() {
		this.init();
	},
	created() {
		
	},
	destroyed() {

	},
	methods : {

		init() {
			this.value = this.param().expression != undefined ? this.param().expression : this.param()
			//this.displayTitle = this.title;

			
		},

		openGraph(){
			
			var paramsLayer = this.getParams();

			var objectToEdit = paramsLayer;

			this.params.forEach((attr) => {
				objectToEdit = objectToEdit[attr]
			})
			
			// Was there already a Graph ?
			if(objectToEdit.expression!= undefined && objectToEdit.graph != undefined)
			{
				//console.log('getting old graph...')
				this.okanMap.graphComponent.originalExpression = objectToEdit.expression;
				this.okanMap.graphSave = objectToEdit.graph;
			}
			else { // first graph
				//console.log('No previous graph...')
				this.okanMap.graphComponent.originalExpression = objectToEdit;
				this.okanMap.graphSave = null;
			}

			this.okanMap.graph_layer = this.layer;
			this.okanMap.graph_layer_params = this.params;
			
			this.okanMap.graph_finalNodeName = this.params.join(' - ');
			this.okanMap.graph_getFields = this.okanMap.sources[this.layer.sourceIndex].structure;

			this.okanMap.graphLayerId = this.layer.id;
			this.okanMap.graphOpen = true;

			
			

			

			this.okanMap.graphComponent.init();

		},

		setConstant(){
			if(this.type == "float"){
				this.$emit('changeVal', {value: 10, layer: this.layer, params: this.params, blueprint: false})
			}
			else if (this.type == "color"){
				this.okanMap.setLayerParamMapBox(this.layer, this.params, '"rgb(0,0,0)"', false);
				this.okanMap.setLayerParam(this.layer, this.params, { r:0, g: 0, b:0, a: 1}, null, null)
			}
		},

		getValue() {

			var paramsLayer = ""
			this.params.forEach( (attr) => {
				paramsLayer += "['"+attr+"']";
			});

			return eval('this.layer.layerTypeParams[this.layer.typeIndex].params'  + paramsLayer)

		},

		editColor(){
			this.value = this.param().expression != undefined ? this.param().expression : this.param()
			this.okanMap.currentColor = this.value;
			//console.log(this.okanMap.currentColor)
			//console.log(this.value)
			this.okanMap.colorBlueprintMode = false;
			this.okanMap.colorLayerApply = this.layer;
			this.okanMap.colorLayersParamsApply = this.params;
			this.okanMap.colorPicker.open()
			this.okanMap.showColorPicker = true;
		},

		clusterChange(e) {
			if(e != undefined && e != null) {

				this.$emit('changeCluster', {value: e.target.checked, layer: this.layer, params: this.params, blueprint: false})
			}
		},

		mapAlignChange(e){
			if(e != undefined && e != null) {
				var newBool = '"viewport"';
				if(e.target.checked)
					newBool = '"map"';

				this.$emit('changeMapAlign', {value: newBool, layer: this.layer, params: this.params, blueprint: false})
			}
			
		},

		onChangeVal(event, val = null){
			
			//console.log(event)

			if(event != null) {
				val = event.target.value;

				this.$emit('changeVal', {value: val, layer: this.layer, params: this.params, blueprint: false, type: this.type})
			}
				
			//console.log(val)
		},

		getParams() {
			return this.layer.layerTypeParams[this.layer.typeIndex].params;
		},

		param() {
			var attributesToChange = ''
			this.params.forEach((attrb) => {
				attributesToChange += "['"+attrb+"']";
			})
			// DIRTY
			var result = eval('this.getParams(this.layer)'+attributesToChange + ';');

			return result;
			
		}


	}
}
</script>


<style src="../../assets/css/ui.css"></style>